const { DEV, MODE } = import.meta.env;

const isGTM = () => window.location.href.indexOf('gtm') > -1;
export const isStaging = MODE === 'staging' && !DEV;
export const isDEV = () => DEV || isGTM();
